export const ROUTE_DRIVER_SEARCH = 'driver-search';
export const ROUTE_DRIVER_PROFILE = 'driver';
export const ROUTE_DRIVER_PROD_SUPPORT = 'driver-prod-support';
